import { useState, useEffect } from "react";
import TransfertFooter from "./TransfertFooter";
import Swal from "sweetalert2";
import { executeTransfert, searchDocuments, getListeClients } from "./Services/transfertService";

const TransfertSimple = ({ title, products, onSubmit, onClose, mode, docType, docId, tierId }) => {
  // State local pour les produits sélectionnés et leurs quantités
  const [selectedProducts, setSelectedProducts] = useState({});
  const [errorsTransfert, setErrorsTransfert] = useState({});
  const [destinationType, setDestinationType] = useState("");
  const [clients, setClients] = useState([]);
console.log(docId)

  const sourceTypes =
    mode === "achat"
      ? [
        { text: "Demande d'achat", value: "DemandeAchat" },
        { text: "Bon de commande", value: "BonCommandeAchat" },
        { text: "Bon de réception", value: "BonReception" },
        { text: "Facture achat", value: "FactureAchat" }
      ]
      : [
        { text: "Devis", value: "DevisVente" },
        { text: "Bon de commande", value: "BonCommandeVente" },
        { text: "Bon de livraison", value: "BonLivraison" },
        { text: "Facture", value: "Facture" }
      ];
  const destinationTypes = sourceTypes;

  //  const sourceTiers=   getListeClients();
  useEffect(() => {
    if (!products || products.length === 0) {
      setSelectedProducts({});
      return;
    }

    const initialSelected = {};

    products.forEach(product => {
      initialSelected[product.id] = product.remainingQuantity;
    });

    // setSelectedProducts(initialSelected);
    const fetchClients = async () => {
      const response = await getListeClients();
      setClients(Object.values(response.data)); // <- transformation en tableau
    };
    fetchClients();
  }, []);

  // const handleCheckboxChangeV1 = (productId, remainingQuantity) => {
  //   setSelectedProducts(prev => {

  //     // Déjà sélectionné → désélectionner
  //     if (Object.prototype.hasOwnProperty.call(prev, productId)) {
  //       const newState = { ...prev };
  //       delete newState[productId];
  //       return newState;
  //     }

  //     // Sélectionner avec quantité initiale = 0
  //     return {
  //       ...prev,
  //       [productId]: product.remainingQuantity
  //     };
  //   });
  // };
  const handleCheckboxChange = (product) => {
    setSelectedProducts(prev => {

      if (Object.prototype.hasOwnProperty.call(prev, product.id)) {
        const newState = { ...prev };
        delete newState[product.id];
        return newState;
      }

      return {
        ...prev,
        [product.id]: product.remainingQuantity
      };
    });
  };
  const handleQuantityChangeV0 = (productId, value, maxQuantity) => {
    const qty = Math.min(Math.max(1, Number(value)), maxQuantity); // toujours entre 1 et maxQuantity
    setSelectedProducts((prev) => ({
      ...prev,
      [productId]: qty,
    }));
  };

  const handleQuantityChange = (productId, value, maxQuantity) => {

    // Permettre de vider temporairement le champ
    if (value === "") {
      setSelectedProducts(prev => ({
        ...prev,
        [productId]: ""
      }));

      return;
    }

    const qty = Number(value);

    // Interdire les valeurs négatives
    if (qty < 0) {
      return;
    }

    // Ne pas dépasser la quantité restante
    const finalQuantity = Math.min(qty, maxQuantity);

    setSelectedProducts(prev => ({
      ...prev,
      [productId]: finalQuantity
    }));
  };

  const handleSubmit = () => {
    // Créer un tableau avec les produits sélectionnés et leur quantité
    const result = products
      .filter((p) => selectedProducts[p.id])
      .map((p) => ({
        ...p,
        quantity: selectedProducts[p.id],
      }));
    onSubmit(result);
  };

  const handleTransfert = async () => {

    const newErrors = {};

    if (!destinationType) {
      newErrors.type = "Le type destination est obligatoire";
    }

    setErrorsTransfert(newErrors);

    console.log("docId =", docId);
    console.log("tierId =", tierId);
    console.log("docType =", docType);

    const result = products
      .filter(item =>
        Object.prototype.hasOwnProperty.call(
          selectedProducts,
          item.id
        )
      )
      .map(item => ({
        ligneId: item.ligneId,    //LIGNE du document

        quantite: Number(selectedProducts[item.id])
      }))
      .filter(item => item.quantite > 0);

    console.log("result =", result);

    if (result.length === 0) {
      Swal.fire(
        "Erreur",
        "Veuillez sélectionner au moins un article.",
        "warning"
      );
      return;
    }

    if (!destinationType) {
      Swal.fire(
        "Erreur",
        "Veuillez sélectionner le type destination.",
        "warning"
      );
      return;
    }

    const docs = [{
      sourceDocumentId: docId,
      tierId: tierId,
      lignes: result
    }];

    const payload = {
      destinationDocumentType: destinationType,
      sourceType: docType,
      documents: docs
    };

    console.log(
      "PAYLOAD =",
      JSON.stringify(payload, null, 2)
    );

    await executeTransfert(payload);

    onClose();

    Swal.fire({
      toast: true,
      position: "top-end",
      icon: "success",
      title: "Transfert effectué avec succès !",
      showConfirmButton: false,
      timer: 2000
    });
  };
  return (
    // <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
    <div className="modal show d-block">

      <div className="modal-dialog modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h5>{title}</h5>
            <button className="close" onClick={onClose}>×</button>
          </div>
          <div className="modal-body">
            <table className="table">
              <thead>
                <tr>
                  <th>Choisi</th>
                  <th>Code</th>
                  <th>Article</th>
                  <th>Stock</th>
                  <th>Quantité</th>
                  <th>Déjà transférée</th>
                  <th>Restante</th>
                  <th>À transférer</th>
                </tr>
              </thead>
              <tbody>
                {products.map((product) => (
                  <tr key={product.id}>
                    <td>
                      {/* <input
                        type="checkbox"
                        // checked={!!selectedProducts[product.id]}
                        checked={selectedProducts[product.id] !== undefined}  
                        onChange={() => handleCheckboxChange(product.id, product.quantite
                        )}
                      /> */}
                      <input
                        type="checkbox"
                        checked={Object.prototype.hasOwnProperty.call(
                          selectedProducts,
                          product.id
                        )}
                        onChange={() => handleCheckboxChange(product)}
                      />
                    </td>
                    <td>{product.code}</td>
                    <td>{product.articleName}</td>
                    <td>{product.stockQuantity}</td>
                    <td>{product.quantite}</td>
                    <td>{product.transferredQuantity}</td>
                    <td>{product.remainingQuantity}</td>
                    <td>
                      {/* <input
                        type="number"
                        min={0}
                        max={product.remainingQuantity}
                        value={selectedProducts[product.id] || ""}
                        onChange={(e) =>
                          handleQuantityChange(product.id, e.target.value, product.remainingQuantity)
                        }
                        disabled={!selectedProducts[product.id]}
                      /> */}
                      <input
                        type="number"
                        min={0}
                        max={Math.min(
                          product.remainingQuantity,
                          product.stockQuantity
                        )} value={
                          Object.prototype.hasOwnProperty.call(
                            selectedProducts,
                            product.id
                          )
                            ? selectedProducts[product.id]
                            : product.remainingQuantity
                        }
                        onChange={(e) =>
                          handleQuantityChange(
                            product.id,
                            e.target.value,
                            product.remainingQuantity
                          )
                        }
                        disabled={
                          !Object.prototype.hasOwnProperty.call(
                            selectedProducts,
                            product.id
                          )
                        }
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="modal-footer  justify-content-center">
            {/* <button className="btn btn-primary" onClick={handleSubmit}>Exporter</button>
            <button className="btn btn-secondary" onClick={onClose}>Annuler</button> */}
            <TransfertFooter
              destinationType={destinationType}  //vient du footer
              destinationTypes={destinationTypes}  //ok destination
              errors={errorsTransfert}
              setDestinationType={setDestinationType}
              onTransfert={handleTransfert}

            />
          </div>

        </div>
      </div>

    </div>

  );
}

export default TransfertSimple;
